import { createSelector } from 'reselect';

import ProjectsSelectors from './projects.selectors';
import { userRoleCheckers } from '../../../../shared/helpers';

const selectRequestStatus = (state) => state.users.status;

const selectAllUsers = (state) => state.users.items || [];

const selectUsersByProjectId = (projectId) => createSelector(
  ProjectsSelectors.selectProjectById(projectId),
  selectAllUsers,
  (project, users) => {
    const usersIds = [
      project?.writerId,
      project?.editorId,
      project?.saleId,
      project?.customerId,
      project?.developmentalEditorId,
      project?.contentTeamId,
      project?.proProofreaderId,
    ];
    const result = [];
    usersIds.forEach((userId) => {
      if (userId) {
        const foundUser = users.find((user) => user._id === userId);
        if (foundUser) result.push(foundUser);
      }
    });

    return result;
  },
);

const selectCustomers = createSelector(
  selectAllUsers,
  (users) => users.filter(({ role }) => userRoleCheckers.isCustomer(role)) || [],
);

const selectEditors = createSelector(
  selectAllUsers,
  (users) => users.filter(({ role }) => userRoleCheckers.isEditor(role)) || [],
);

const selectDevelopmentalEditors = createSelector(
  selectAllUsers,
  (users) => users.filter(({ role }) => userRoleCheckers.isDevelopmentalEditor(role)) || [],
);

const selectProProofreaders = createSelector(
  selectAllUsers,
  (users) => users.filter(({ role }) => userRoleCheckers.isProProofreader(role)) || [],
);

const selectContentTeams = createSelector(
  selectAllUsers,
  (users) => users.filter(({ role }) => userRoleCheckers.isContentTeam(role)) || [],
);

const selectWriters = createSelector(
  selectAllUsers,
  (users) => users.filter(({ role }) => userRoleCheckers.isWriter(role)) || [],
);

const selectUserById = (userId) => createSelector(
  selectAllUsers,
  (users) => users.find(({ _id }) => _id === userId) || {},
);

export default {
  selectRequestStatus,
  selectAllUsers,
  selectUsersByProjectId,
  selectCustomers,
  selectEditors,
  selectWriters,
  selectUserById,
  selectDevelopmentalEditors,
  selectContentTeams,
  selectProProofreaders,
};
